import type { RumPublicApi } from "@datadog/browser-rum-core";
import { getGlobalObject } from "./utils/getGlobalObject";

export function addError(...args: Parameters<RumPublicApi["addError"]>) {
  getGlobalObject<Window>().DD_RUM?.addError(...args);
}
